
import { useLanguageContext } from "../../../../../../Components/Languages/Langs/LanguageContext";
import { useAppDispatch } from "../../../../../../Redux/store";
import { deleteUserTask } from "../../../../../../Redux/tasks/operators";
import { Task } from "../../../../../../Redux/tasks/slice";
import { ButtonDeleteContainer, ButtonGreenDelete, ButtonRedDelete, DeleteModelContainer, TitleModelDelete } from "./DeleteModelStyles.styled";

interface DeleteTaskModelProps {
    onClose: () => void;
    deleteTaskById: (updater: (prev: Task[]) => Task[]) => void;
    task: Task;
}

export const DeleteTaskModels: React.FC<DeleteTaskModelProps> = ({ task, deleteTaskById, onClose }) => {
  const { t } = useLanguageContext();
  const dispatch = useAppDispatch();

  const deleteTask = async (_id: string) => {
    try {
      const resultAction = await dispatch(deleteUserTask(_id)).unwrap();
      console.log("Deleted:", resultAction.message);

      deleteTaskById(prev => prev.filter(t => t._id !== _id));
      onClose(); // закриємо модалку після видалення
    } catch (error) {
      console.log("Unwrapped error:", error);
    }
  };

  return (
    <DeleteModelContainer>
      <TitleModelDelete>{t("privateTraslate.Models.DeleteModelTitle")}</TitleModelDelete>
      <ButtonDeleteContainer>
        <ButtonRedDelete type="button" onClick={() => deleteTask(task._id)}>{t("privateTraslate.Models.DeleteModelTextYes")}</ButtonRedDelete>
        <ButtonGreenDelete type="button" onClick={onClose}>{t("privateTraslate.Models.DeleteModelTextNo")}</ButtonGreenDelete>
      </ButtonDeleteContainer>
    </DeleteModelContainer>
  );
};